import Pill from "PFComponents/pill/pill";
import { Typography } from "PFComponents/typography/typography";
import colors from "PFTheme/tokens/colors";
import { CustomValueState } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./skill_state.module.scss";

type SkillStateProps = {
  state: CustomValueState;
};

const STATE_COLORS: Record<CustomValueState, string> = {
  approved: colors.paletteEcharts5,
  created: colors.paletteEcharts6,
  blocked: colors.paletteBlack0,
  merged: colors.paletteBlue0
};

export const SkillState = ({ state }: SkillStateProps) => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "table.cells.status" });

  return (
    <Pill style={{ backgroundColor: STATE_COLORS[state] }} small>
      <Typography variant={"labelRegular"} className={css.statePill}>
        {t(state)}
      </Typography>
    </Pill>
  );
};
